import { Button, Icons, List, Space, Tabs } from '@pankod/refine-antd'
import { IResourceComponentsProps, useCan } from '@pankod/refine-core'
import Head from 'next/head'

import UploadCSVButton from '@resources/pendaftaran-diklat/admin-pendaftaran/block/UploadCSVButton'
import AdminPendaftaranTableList from '@resources/pendaftaran-diklat/admin-pendaftaran/block/AdminPendaftaranTableList'
import ErrorLogsTableList from '@resources/pendaftaran-diklat/admin-pendaftaran/block/ErrorLogsTableList'

export const AdminPendaftaranList: React.FC<IResourceComponentsProps> = ({
  options,
}) => {
  const { data: canUploadAdminPendaftaran } = useCan({
    action: 'field',
    resource: 'admin-pendaftaran-management',
    params: { field: 'upload' },
  })

  const downloadCSVTemplate = () => {
    if (typeof window === 'undefined') return
    const headers = ['email', 'npsn', 'name', 'program_id', 'program_local_id']
    const row = ['john.doe@belajar.id', '3323331123', 'John Doe', '101', '1011']

    const csvContent = [headers.join(','), row.join(',')].join('\n')
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'admin-pendaftaran_template.csv')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <>
      <List
        title="Admin Pendaftaran"
        resource="admin-pendaftaran-management"
        headerButtons={
          canUploadAdminPendaftaran?.can && (
            <Space>
              <Button
                onClick={() => {
                  downloadCSVTemplate()
                }}
                type="text"
                icon={<Icons.DownloadOutlined />}
              >
                Unduh Template
              </Button>
              <UploadCSVButton key="upload-btn" />
            </Space>
          )
        }
      >
        <Head>
          <title>LMS Admin | {options?.label}</title>
        </Head>
        <Tabs size="small" type="card">
          <Tabs.TabPane key={0} tabKey="admin-list" tab="Daftar Admin">
            <AdminPendaftaranTableList />
          </Tabs.TabPane>
          {canUploadAdminPendaftaran?.can && (
            <Tabs.TabPane
              key={1}
              tabKey="error-logs"
              tab={
                <>
                  <i>Error Logs</i>
                </>
              }
            >
              <ErrorLogsTableList />
            </Tabs.TabPane>
          )}
        </Tabs>
      </List>
    </>
  )
}
